<template>
    <article class="square-banners__item">
        <BaseLink
            :href="url"
            :title="title"
            class="square-banners__image-wrapper"
        >
            <ProgressiveImage
                :data="{ src: banner, alt: title }"
                class="square-banners__image"
            />
        </BaseLink>
        <h2 class="square-banners__title">
            {{ title }}
        </h2>
        <p class="square-banners__description">
            {{ description }}
        </p>
    </article>
</template>

<script>
import ProgressiveImage from '~/components/common/Image/ProgressiveImage';
import BaseLink from '~/components/common/Link/BaseLink';

export default {
    name: 'ItemSquareBanners',
    components: { BaseLink, ProgressiveImage },
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        banner: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    .square-banners {
        &__image-wrapper {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            border: solid 4px $color-castoWhite;
            background: $color-slate5;
        }

        &__image, &__title, &__description {
            width: 100%;
            display: inline-block;
            color: $color-slate100;
            font: $font-weight-regular 16px/14px $goodHomeFontFamily;
            text-align: center;

            a {
                color: $color-slate100;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &__image {
            width: 100%;
            height: auto;
        }

        &__title {
            margin: 35px 0 15px 0;
            padding: 0;
            font: $font-weight-bold 20px/20px $goodHomeFontFamily;
            color: $color-slate100;
        }

        &__description {
            padding: 0;
            margin: 0;
            font: $font-weight-light 14px/18px $goodHomeFontFamily;
            color: $color-slate100;
        }
    }
</style>
